const GetDashboardARCurrentYearDatesSelector = ({
  metadataDashboard: { dashboardARCurrentYearDates }
}) => dashboardARCurrentYearDates;

export default GetDashboardARCurrentYearDatesSelector;
